import Model from './Model';
import Vue from 'vue';

export default class Client extends Model {
    address;
    address_number;
    address_number_suffix;
    benefits;
    city;
    date_of_birth;
    education;
    email;
    first_name;
    gender;
    initials;
    intellectual_ability;
    last_name;
    maiden_name;
    mobile_number;
    name;
    nationality;
    phone_number;
    postal_code;

    static apiPath() {
        return 'clients';
    }

    create() {
        // Override the create() action to invite the client instead
        return Vue.axios.post('client/invite', this.toJson()).then(resp => {
            this.id = resp.data.id;
            return this;
        }).catch(({ status, errors }) => {
            console.error('[ Client ]', 'Error inviting client', status, errors);
            throw { status, errors };
        });
    }
}



// WEBPACK FOOTER //
// ./src/models/Client.js